export const initialArchAnimationDelay = 1500;
export const zoomingDuration = 1500;
export const headerFadeoutDuration = 600; // Remember subtitle delay of 100ms

export const colors = {
  white: '#ffffff',
  black: '#000000',
  grey: '#C7C7C7',
  grey2: '#8D8D8D',
  flatGreen: '#0A5656',
  flatGreenLight: '#0C6969',
  flatGreenDark: '#063333',
  flatBlue: '#0B43B9',
  flatBlueLight: '#0F54E3',
  flatBlueDark: '#062361',
  lightGreen: '#21BDB9',
  lightBlue: '#7AABFC',
};

export const durations = {
  carouselRotationDuration: 1000,
  viewDetailsDuration: 300,
  scalePillarDuration: 600,
  revealPillarDuration: 2000,
  serviceTitleFadeDuration: 300,
};

export const easings = {
  pillarScale: 'cubic-bezier(.17,.17,.5,1)',
  pillarTranslate: 'cubic-bezier(.5,0,.5,1)',
  pillarReveal: 'cubic-bezier(.33,0,0,1)',
  viewDetailsOpacity: 'ease-in-out',
};

export const delays = {
  revealAnimation: 200,
};
